import { render, staticRenderFns } from "./Procurement.vue?vue&type=template&id=53d99244&scoped=true&"
import script from "./Procurement.vue?vue&type=script&lang=js&"
export * from "./Procurement.vue?vue&type=script&lang=js&"
import style0 from "./Procurement.vue?vue&type=style&index=0&id=53d99244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d99244",
  null
  
)

export default component.exports